export const classes = {
	active: 'filter__element--active',
	filterAlwaysOn: 'filter--always-on',
	filterSelectFirst: 'filter--select-first',
};

export const selectors = {
	activeFilterElement: `.${classes.active}`,
	filterButton: '.filter__element',
	filterNavigation: '.filter',
	filterSelect: 'select',
	tiles: 'div[data-cat], li[data-cat], a[data-cat]',
};

export const FILTER_CHANGE_EVENT_TYPE = 'mcflyFilterChange';
